import styled from "styled-components";
import BaseTag from "./BaseTag";

export default styled(BaseTag)(props => ({
  ...props.theme.tag.base,
  ...props.theme.tag.surplus,
}));
